export function replaceUrlParams(
  url: string,
  params: Record<string, string | number>
): string {
  return url.replace(/{(\w+)}/gi, (str, bracket) => {
    return bracket in params ? `${params[bracket]}` : "";
  });
}
